export const Food=[
    {
        Name:"Biryani",
        img:"https://www.foodlocale.in/wp-content/uploads/2023/01/briyani.jpg",
        desc:"A rice dish made with a variety of spices, meats such as chicken or lamb, and vegetables.",
        sales:"$32000",
        likes:"54000",
        Ratings:"5*",        
    },
    {
        Name:"Butter Chicken",
        img:"https://foodlocale.in/wp-content/uploads/2023/01/Butter_chicken.jpg",
        desc:"A dish made with marinated chicken cooked in a creamy tomato-based sauce.",
        sales:"$30000",
        likes:"53034",
        Ratings:"5*",        
    },
    {
        Name:"Fried Rice",
        img:"https://static.toiimg.com/thumb/75581339.cms?width=1200&height=900",
        desc:"Fried rice is a delicious Asian dish made by stir-frying rice with veggies, eggs, and seasoning, creating a savory and satisfying meal.",
        sales:"$29003",
        likes:"52000",
        Ratings:"5*",        
    },
    {
        Name:"Samosas",
        img:"https://foodlocale.in/wp-content/uploads/2023/01/crispy-mini-samosas.jpg",
        desc:"Fried or baked pastry filled with a variety of fillings such as potatoes, peas, and meat.",
        sales:"$26847",
        likes:"56476",
        Ratings:"5*",        
    },
    {
        Name:"Tandoori Chicken",
        img:"https://foodlocale.in/wp-content/uploads/2023/01/Tandoori_chicken.png",
        desc:"A dish made with marinated chicken cooked in a tandoor oven.",
        sales:"$25484",
        likes:"55659",
        Ratings:"5*",        
    },
    {
        Name:"Momos",
        img:"https://foodlocale.in/wp-content/uploads/2023/01/Chicken-Momos.jpg",
        desc:"A popular street food originating from Tibet, now widely popular in India, made with steamed or fried dough filled with a variety of fillings such as meat, vegetables, or cheese.",
        sales:"$24000",
        likes:"52000",
        Ratings:"4.5*",        
    },
    {
        Name:"Pulao",
        img:"https://foodlocale.in/wp-content/uploads/2023/01/Peas-Pulao1.png",
        desc:"A rice dish made with a variety of spices, meats, and vegetables.",
        sales:"$23755",
        likes:"50000",
        Ratings:"4*",        
    },
    {
        Name:"Naan",
        img:"https://foodlocale.in/wp-content/uploads/2023/01/north_indian_food-1024x682.jpg",
        desc:"A leavened flatbread made with wheat flour, traditionally cooked in a tandoor oven.",
        sales:"$20000",
        likes:"45000",
        Ratings:"3*",        
    },
    {
        Name:"Seafood",
        img:"https://foodlocale.in/wp-content/uploads/2023/01/sea-bream.jpg",
        desc:"India is surrounded by sea and there are many regions in India where seafood is very popular, such as Goa, and some coastal areas, where you can find a variety of seafood dishes",
        sales:"$18000",
        likes:"32000",
        Ratings:"3*",        
    },
    {
        Name:"Indian Sweets",
        img:"https://www.foodlocale.in/wp-content/uploads/2023/01/Indian_Sweets.jpg",
        desc:"India is also famous for its sweets, there are many different types of sweets available in India, such as Gulab Jamun, Rasgulla, Kulfi, Jalebi, etc.",
        sales:"$30000",
        likes:"40000",
        Ratings:"3*",        
    },
]